import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

export const shadow = {
  shadowColor: '#00000029' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.8,
  shadowRadius: 4,
  elevation: 3,
}

export const styles = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 5,
    shadowColor: Colors.LIGHT_GREY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    flex: 1,
    marginVertical: 16,
    marginHorizontal: 16,
    backgroundColor: 'WHITE',
    paddingHorizontal: 16,
    paddingVertical: 16,
    overflowY: 'auto',
  } as BoxProps,
  titleText: {
    fontSize: 20,
    color: 'BLACK_21' as ColorOptions,
    textAlign: 'left',
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  flexRowView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    pb: 16,
  } as BoxProps,
  emptyContainer: {
    alignContent: 'center',
    flex: 1,
  } as BoxProps,
  tableContainer: (isLoading: boolean) =>
    ({
      alignContent: 'center',
      flexGrow: 1,
      marginTop: isLoading ? 24 : undefined,
    } as BoxProps),
}
